// extracted by mini-css-extract-plugin
export default {"wrapper":"SideBar_wrapper__k3R2J","show":"SideBar_show__ZbDpr"};